// LIDControlSoilForm.jsx
import { useState, useEffect } from "react"
import { Grid } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @returns UI for interactive swmm modeling.
 */
export default function LIDControlSoilForm({model, setModel, target, controlType}) {
  const [objsIndexes, setObjsIndexes] = useState([0, 1, 2, 3, 4, 5, 6])
  const [typeCode] = useState('SOIL')

  useEffect(()=> {
    setObjsIndexes([0, 1, 2, 3, 4, 5, 6])
  }, [controlType])

  const UIParams = [
    {name: 'Thick', uiText: 'Thickness (in or mm)'},
    {name: 'Por',   uiText: 'Porosity (volume fraction)'},
    {name: 'FC',    uiText: 'Field Capacity (volume fraction)'},
    {name: 'WP',    uiText: 'Wilting Point (volume fraction)'},
    {name: 'Ksat',  uiText: 'Conductivity (in/hr or mm/hr)'},
    {name: 'Kcoeff',uiText: 'Conductivity Slope'},
    {name: 'Suct',  uiText: 'Suction Head (in or mm)'},
  ]

  // When there is a change to an input element, modify the model.
  const updateValue = (val, type, varName) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ''

    if( model && model.LID_CONTROLS && model.LID_CONTROLS[target] ){
      setModel(prev => ({
        ...prev,
        LID_CONTROLS:{
          ...prev.LID_CONTROLS,
          [target]: {
            ...prev.LID_CONTROLS[target],
            [type]: {
              ...prev.LID_CONTROLS[target][type],
              [varName]: val
            }
          }
        }
      }))
    }
  }

  return(
    <>
    {
      model &&
      model.LID_CONTROLS &&
      model.LID_CONTROLS[target] &&
      <>
      <Grid container style={{fontSize: '12px'}}>
        <Grid item xs={9} style={{fontSize: '12px'}}>
          <div style={{borderBottom:'3px solid #fff'}}>Parameter</div>
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>Value</div>
        </Grid>
          {
            objsIndexes.map(v=>
              <Grid container key={'lidsoil' + v}>
                <Grid item xs={9} style={{fontSize: '12px'}}>
                  <label  style={{height: '22px'}}
                          className='editor-small'
                          key={'LID_CONTROLS_uiText'+UIParams[v].name.toString()}
                  >{UIParams[v].uiText}</label>
                </Grid>
                <Grid item xs={2}>
                  <input  type = "number"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{updateValue(e.target.value, typeCode, UIParams[v].name)}}
                    value={model.LID_CONTROLS[target][typeCode][UIParams[v].name]}
                    id={'LID_CONTROLS'+v.toString()}
                    key={'LID_CONTROLS'+v.toString()}
                  />
                </Grid>
              </Grid>
            )
          }
      </Grid>
      </>
    }
    </>
  )
}